import React, { Component } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import history from '../history';
import { flags, isFeatureOn } from '../Common/FeatureFlag/features';

const SeverityLevel = {
	Verbose: 0,
	Information: 1,
	Warning: 2,
	Error: 3,
	Critical: 4
};

const convertToClass = FuncComponent => {
	return class extends Component {
		render() {
			return <FuncComponent {...this.props} />;
		}
	};
};

const disableTelemetry = !isFeatureOn(flags.FEI);
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
	config: {
		instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
		disableTelemetry,
		extensions: [reactPlugin],
		extensionConfig: {
			[reactPlugin.identifier]: { history }
		},
        loggingLevelConsole: 2,
        enableRequestHeaderTracking: true,
        enableAutoRouteTracking: true
	}
});

appInsights.loadAppInsights();

const withClsCompTracking = componentName => ClsComponent => withAITracking(reactPlugin, ClsComponent, componentName);

const withFuncCompTracking = componentName => FuncComponent => withClsCompTracking(componentName)(convertToClass(FuncComponent));

const trackEvent = eventName => appInsights.trackEvent({ name: eventName });

const trackError = (page, method, message = '') => appInsights.trackTrace(`Error: ${page} - ${method}`, { message }, SeverityLevel.Error);

const setUser = user => {
    appInsights.clearAuthenticatedUserContext();
    if (user?.userName) {
        const userName = user.userName
            .replace(' ', '_')
            .replace(/[,;=|]/, '');
        appInsights.setAuthenticatedUserContext(userName, undefined, true);
    }
}

export { appInsights, trackEvent, trackError, withClsCompTracking, withFuncCompTracking, setUser };
